export const FEATURE_FLAGS_KEY = 'toggledFlags';
export const LOCAL_FEATURE_FLAGS_KEY = 'localFeatureFlags';
export const STRING_SETTINGS_KEY = 'stringSettings';
export const LOCAL_ENABLED_INTEGRATIONS_KEY = 'localEnabledIntegrations';
export const LOCAL_COMMUNITY_CAMERAS_MOCK_KEY = 'localCommunityCamerasMock';
export const LOCAL_COMMUNITY_CAMERAS_MODELS_KEY = 'localCommunityCamerasModels';
export const DEFAULT_COMMUNITY_CAMERA_MODELS = ['Ring'];
